// export const base_url = '/' 

// git io
//export const base_url = '/multi-pose-react/build/'
export const base_url = '/multipose-react/build/'
//export const base_url = '/multiposereactjs/build/'
